import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-icon-upload',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon-upload.ui-component.html',
  styleUrl: './icon-upload.ui-component.scss',
})
export class IconUploadUiComponent {}
